import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Card, Col, Row, Spin } from 'antd';

const HeaderCard: React.FC = () => {
    const [loading, setLoading] = useState(true);
  const claimDetails: any = useSelector(
    (state: RootState) => state?.claimsDetails?.claimDetails,
  );
  const formatDateString = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  useEffect(() => {
    // creating a delay
    setTimeout(() => {
        setLoading(false);
    }, 2000);
  }, []);
  return (
    <div style={{width: '80vw', paddingLeft: '70px'}}>
        <Spin spinning = {loading}>
        <Card style={{ backgroundColor: '#E9ECF0' }}>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Claim No</label>
            <div>{claimDetails.payerClaimNo}</div>
          </Col>
          <Col span={6}>
            <label>Date Of Admission</label>
            <div>{formatDateString(claimDetails.doa)}</div>
          </Col>
          <Col span={6}>
            <label>Date of Discharge</label>
            <div>{formatDateString(claimDetails.dod)}</div>
          </Col>
          <Col span={6}>
            <label>Claimed Amount</label>
            <div>Rs.{claimDetails.claimedAmount}</div>
          </Col>
        </Row>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Approved Amount</label>
            <div>Rs.{claimDetails.approvedAmount}</div>
          </Col>
          <Col span={6}>
            <label>Courier tracking No</label>
            <div>{claimDetails.courierTrackId}</div>
          </Col>
          <Col span={6}>
            <label>Courier Provider Service</label>
            <div>{claimDetails.courierProvider}</div>
          </Col>
          <Col span={6}>
            <label>Courier Status</label>
            <div>{claimDetails.courierStatus}</div>
          </Col>
        </Row>
      </Card>
        </Spin>
    </div>
  );
};

export default HeaderCard;
